import Vue from 'vue'
import VueLoggerPlugin from 'vuejs-logger/dist/vue-logger'
import Vue2Filters from 'vue2-filters'
import moment from 'moment'
import moment_timezone from 'moment-timezone'
import BootstrapVue from 'bootstrap-vue'
import IdleVue from 'idle-vue'

import { library } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'
import { faVideo, faUser, faInfoCircle, faCalendarDay } from "@fortawesome/free-solid-svg-icons";

import App from './App'
import router from './router'
import store from './store'

// noinspection JSUnresolvedVariable
moment_timezone.tz.setDefault('America/Chicago')

import '../public/css/styles.scss';

library.add(faVideo, faUser, faInfoCircle, faCalendarDay);

Vue.component('font-awesome-icon', FontAwesomeIcon);

Vue.filter('toCurrency', function (input) {
    let value=parseFloat(input)
    if (typeof value !== "number") {
        return value
    }
    const formatter = new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 2
    })
    return formatter.format(value)
})

const eventsHub = new Vue()
Vue.use(IdleVue, {
    eventEmitter: eventsHub,
    store,
    idleTime: 900000, //15min
    startAtIdle: false
})

const isProduction = process.env.NODE_ENV === 'production'

Vue.use(VueLoggerPlugin, {
    isEnabled: true,
    logLevel: isProduction ? 'error' : 'debug',
    stringifyArguments: false,
    showLogLevel: true,
    showMethodName: true,
    separator: '|',
    showConsoleColors: true
})
Vue.use(Vue2Filters)
Vue.filter('formatDate', (value) => {
    if (value) {
        return moment(String(value)).format('MM/DD/YYYY')
    }
    return ''
})
Vue.use(BootstrapVue)

Vue.config.productionTip = false

new Vue({
    router,
    store,
    render: createElement => createElement(App)
}).$mount('#App')